/**
 * Created by boris on 3/17/17.
 */
/**
 * Created by boris on 3/7/17.
 */
import React from 'react'
import Paper from '@material-ui/core/Paper'
// import UserPageInfo from '../UserPageInfo'
import AddStory from './AddStory'
// import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import '../../css/AddStory/AddStory.css'
import { Box } from '@material-ui/core'

class AddStoryPage extends React.Component {
  render() {
    // const { user } = this.props.auth
    return (
      <Box className="page-content">
        <Paper elevation={8} className="user-page">
          <div className="add-story-content">
            <AddStory />
          </div>
        </Paper>
      </Box>
    )
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  }
}

export default connect(mapStateToProps)(AddStoryPage)
